import React, {useEffect, useRef} from 'react';
import * as PIXI from 'pixi.js';
// import {t4} from './DrawingDataType';
import {Guide} from './Guide';
import {Store} from "../models/Store";

type P = {
    size?: number
};

const defaultSize = 614;
const backgroundColor = 0xffffff;

export const ReadonlyCanvas = (props: P) => {

    const size = props.size || defaultSize;

    // ref

    const containerElementRef = useRef(null);

    //

    useEffect(() => {
        const app = new PIXI.Application({
            backgroundColor: backgroundColor,
            width: size,
            height: size,
        });

        const faceGuideSprite = new Guide(Store.data.guide);
        faceGuideSprite.scale.set(.5 * size / defaultSize);
        faceGuideSprite.position.set(607 / 2 - 930 / 4, 607 / 2 - 1026 / 4);
        app.stage.addChild(faceGuideSprite);

        const g = new PIXI.Graphics();

        const data = Store.data;

        for (let i of data.paths) {
            const color = i.color;
            const width = i.width || 2;
            const points = i.points;
            const p = points[0];
            const a = (value: number) => {
                return value * (size / defaultSize);
            };
            g.lineStyle(a(width * 6), color)
                .moveTo(a(p.position.x), a(p.position.y));
            for (let j = 1; j < points.length; j++) {
                const p = points[j];
                g.lineTo(a(p.position.x), a(p.position.y));
            }
        }

        app.stage.addChild(g);

        const containerElement = containerElementRef.current;
        (containerElement as any).appendChild(app.view);
    });

    // render

    return (
        <div ref={containerElementRef}/>
    );
};